export default __webpack_public_path__ + "static/media/GR00023-diamond_mentor.a01da584.svg";